import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nimbus-form-wrapper',
  templateUrl: './form-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormWrapperComponent {
  @HostBinding('class')
  public class: string = 'nimbus-form-wrapper';

  @Input()
  public formGroup: any;
}
